<template>
  <b-modal
    v-model="display"
    :title="`${$t('messageto')} ${toname}`"
    header-bg-variant="danger"
    header-text-variant="light"
    header-class="pt-1 pb-2 modal-header-sm rounded-0"
    body-bg-variant="light"
    body-text-variant="dark"
    footer-bg-variant="dark"
    footer-text-variant="light"
    body-class="pt-4 pl-2 pr-1"
    hide-footer
    centered
    modal-class="modal-fullscreen-md"
    @close="closeModal()"
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid="md">
      <b-form-group
        :description="$t('message')"
      >
        <template #label><label for="message"><b>{{ `${$t('message')}:` }}</b></label></template>
        <b-form-input
          id="message"
          v-model="message"
          type="text"
          :placeholder="$t('entermessage')"
          required
          :class="errors.message ? 'is-invalid' : ''"
        ></b-form-input>
        <span v-if="errors.message" class="invalid-feedback" role="alert">
          <strong v-for="(error, ekey) in errors.message" :key="`message-${ekey}`">{{ error }}</strong>
        </span>
      </b-form-group>

      <b-col cols="12">
        <b-row class="justify-content-center">
          <button class="btn btn-success" @click.stop="sendMessage" :disabled="btnLoading">
            {{ $t('submit') }} <span v-if="btnLoading"><i class="fas fa-spinner fa-spin"></i></span>
          </button>
        </b-row>
      </b-col>
    </b-container>
  </b-modal>
</template>

<script>
function initialDataModal () {
  return {
    touser: null,
    toname: null,
    message: '',
    display: false,
    btnLoading: false,
    errors: {}
  }
}

export default {
  name: 'UserMessage',
  mixins: [],
  props: {},
  components: {},
  data () {
    return initialDataModal()
  },
  methods: {
    openModal () {
      this.display = true
    },
    sendMessage (evt) {
      evt.preventDefault()
      this.errors = {}
      this.btnLoading = true
      this.$store.dispatch('user/sendMessage', { user_id: this.touser, message: this.message })
        .then((response) => {
          this.closeModal()
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.$root.$emit('showAlert', 'danger', error.response.data.message, 7)
            this.errors = error.response.data.errors || {}
          } else {
            this.$root.$emit('showAlert', 'danger', error.message, 7)
          }

          this.btnLoading = false
        })
    },
    closeModal () {
      Object.assign(this.$data, initialDataModal())
      this.display = false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$root.$on('showUserMessage', (user_id, name) => {
      this.toname = name
      this.touser = user_id
      this.openModal()
    })
  },
  beforeDestroy () {
  },
  destroyed() {
    this.$root.$off('showUserMessage')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
